import { Routes } from '@angular/router';
import { BulkPickingEnabledGuard } from '@/shared/guards/bulk-picking-enabled.guard';

export const packingRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./packing.component').then((m) => m.PackingComponent),
    canActivate: [BulkPickingEnabledGuard],
  },
  {
    path: 'order/:id',
    loadComponent: () => import('./packing-order/packing-order.component').then((m) => m.PackingOrderComponent),
  },
];
